// import { getToken } from '@/utils/auth'
// 生成组件的唯一id
export const GUID = () =>
  ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  )

export const noData = (value, str) => {
  return value === undefined || value === null || value === ''
    ? str || '-'
    : value
}

// 拼接图片url
export const formatImgUrl = (url) => {
  // if (!url) return ''
  // url = url.replace(/^(http:|https:)\/\/[^/]+/, '')
  // // eslint-disable-next-line no-undef
  // url = _API_ + 'stream' + url
  return url
}

// 平铺树
export const treeToArray = tree => {
  let arr = []
  const expanded = datas => {
    if (datas && datas.length > 0) {
      datas.forEach(e => {
        arr.push(e)
        expanded(e.childList || e.child || e.children)
      })
    }
  }
  expanded(tree)
  return arr
}

// 格式化文件大小
export const formatFileSize = (value) => {
  if (!value) {
    return '-'
  }
  let KB = parseInt(value / 1024)
  if (KB > 1024) {
    let MB = parseInt(KB / 1024)
    return MB + 'MB'
  }
  return KB + 'KB'
}

// 科学计数

export function numFormat (num) {
  num = num.toString().split('.') // 分隔小数点
  var arr = num[0].split('').reverse() // 转换成字符数组并且倒序排列
  var res = []
  for (var i = 0, len = arr.length; i<len; i++) {
    if (i % 3 === 0 && i !== 0) {
      res.push(',') // 添加分隔符
    }
    res.push(arr[i])
  }
  res.reverse() // 再次倒序成为正确的顺序
  if (num[1]) { // 如果有小数的话添加小数部分
    res = res.join('').concat('.' + num[1])
  } else {
    res = res.join('')
  }
  return res
}

// 防抖
export function debounce (fn, delay) {
  // 时间期限
  var delays = delay || 200
  var timer
  // 闭包
  return function () {
    // 考虑作用域，上下文环境，apply需要用到this对象
    var th = this
    // 接收的参数用 ES6 中的 rest 参数统一存储到变量 args 中。arguments就是传入的参数数组,而且个数可以不确定的传回给fn（不确定函数到底有多少个参数，用arguments来接收）
    var args = arguments
    // 判断还在定时，说明当前正在一个计时过程中，并且又触发了相同事件。所以要取消当前的计时，重新开始计时
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(function () {
      timer = null
      // 执行方法
      fn.apply(th, args)
    }, delays)
  }
}

// 节流 定时器 + 时间戳
export function throttle (func, delay) {
  var timer = null
  var startTime = Date.now()
  return function () {
    // 结束时间
    var curTime = Date.now()
    // 间隔时间 = 延迟的时间 - （结束时间戳 - 开始时间戳）
    var interval = delay - (curTime - startTime)
    var th = this
    var args = arguments
    clearTimeout(timer)
    if (interval <= 0) {
      // 证明可以触发了
      func.apply(th, args)
      // 重新计算开始时间
      startTime = Date.now()
    } else {
      // 继续等待
      timer = setTimeout(func, interval)
    }
  }
}
